import { convRate, bracketRate, } from "@cachables";
import type { ConnectedCombinedDataStoreState, } from "@types";
import type { AmountString, } from "@bracket/types";



/**
 * Enforces maximum output amount. In the case of REDEEM mode, it resolves either as the balance of the input token or the balance of the treasury vault - whichever is lower.
 * @summary For REDEEM mode, calculates the maximum allowed input amount by converting input and output amounts to ETH equivalents and applying conversion rates
 * @param {Function} get - Function to get the current store state
 * @returns {Promise<AmountString>} The adjusted input balance that respects maximum output constraints
 * @throws {Error} If conversion rate calculations fail
 */
export const enforceMaximum = async ( get: () => ConnectedCombinedDataStoreState ): Promise<AmountString> => {

	const {
    mode,
    inputBalance,
    outputMaximum,
    tokenIn,
    tokenOut,
   } = get().swap;

   switch(mode) {

    case "REDEEM": {
      const [
        tokenInRate,
        tokenOutRate,
        brktRate,
      ] = await Promise.all([
        convRate({ token: tokenIn, }),
        convRate({ token: tokenOut, }),
        bracketRate(),
      ]);

    const inEthAmount = Number(inputBalance) / tokenInRate;
    const maxEthAmount = (Number(outputMaximum) / 1e18) / tokenOutRate;
    const next = maxEthAmount < inEthAmount
      ? (maxEthAmount * tokenOutRate * brktRate).toFixed(5)
      : inputBalance;

      return next;

    }

    case "BUY": {
 
      console.warn("enforceMaximum invoked for BUY mode");
      return inputBalance;
    }

    default: {
 
      console.warn("enforceMaximum invoked with unknown mode", mode);
      return inputBalance;
    }

  }

}